<template>
  <div class="c-settings-header">
    <div class="c-settings-header__back-button" v-if="withBackButton">
      <el-button class="r-button icon-button" circle @click="back">
        <r-icon name="arrow-back" :size="14" />
      </el-button>
    </div>
    <div class="c-settings-header__title">
      <r-title type="subtitle-1">{{ title }}</r-title>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    withBackButton: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    back() {
      this.$emit("back");
    }
  }
};
</script>

<style lang="scss">
.c-settings-header {
  display: flex;
  align-items: center;
  border-bottom: 1px solid transparent;
  border-color: var(--dividers_low_contrast) !important;
  height: 36px;
  padding: 0 2px;

  &__back-button {
    margin-right: 8px;
  }

  &__title {
    flex: 1;
    text-align: center;
  }
}
</style>
